import React from "react";
import * as PersonComponents from "../../Person";
import { IconUser, userToPerson } from "../Icon";

export type UserIconNameDescriptionProps = Omit<PersonComponents.PersonIconNameDescriptionProps, "person"> & {
	user: IconUser;
};

export function UserIconNameDescription({ user, ...props }: UserIconNameDescriptionProps) {
	const person = React.useMemo(() => userToPerson(user), [user]);

	return <PersonComponents.PersonIconNameDescription person={person} linkID={user.id} {...props} />;
}
